import gql from 'graphql-tag';

export const ServiceListQuery = gql`
	query ServiceListQuery(
		$first: Int,
		$cursor: String,
		$orderBy: ServiceOrderBy,
		$orderDesc: Boolean,
		$filter: ServiceFilterInput
	) {
		entities: services(first: $first, after: $cursor, orderBy: $orderBy, orderDesc: $orderDesc, filter: $filter) {
			edges {
				node {
					id
					localId
					name
					type
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}

	}
`;


